import { render, staticRenderFns } from "./DxDetailTabs.vue?vue&type=template&id=85f5c968&scoped=true&"
import script from "./DxDetailTabs.vue?vue&type=script&lang=js&"
export * from "./DxDetailTabs.vue?vue&type=script&lang=js&"
import style0 from "./DxDetailTabs.vue?vue&type=style&index=0&id=85f5c968&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f5c968",
  null
  
)

export default component.exports